export type BffFlagInputs = {
  viteUseBff: string | undefined;
  viteBffBaseUrl: string | undefined;
  configuredUseBff: boolean | undefined;
  configuredBffBaseUrl: string | undefined;
  environment: string;
};

export type LeadsServiceKind = 'mock' | 'bff' | 'legacy';

const DEFAULT_BFF_BASE_URL = '/bff';
const BFF_DEFAULT_ON_ENVIRONMENTS: ReadonlySet<string> = new Set(['dev']);

const parseBooleanFlag = (value: string | undefined): boolean | undefined => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
};

const nonBlank = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

export const resolveUseBff = (inputs: BffFlagInputs): boolean => {
  const override = parseBooleanFlag(inputs.viteUseBff);
  if (override !== undefined) return override;
  if (inputs.configuredUseBff !== undefined) return inputs.configuredUseBff;
  return BFF_DEFAULT_ON_ENVIRONMENTS.has(inputs.environment);
};

export const resolveBffBaseUrl = (inputs: BffFlagInputs): string => {
  return nonBlank(inputs.viteBffBaseUrl) ?? nonBlank(inputs.configuredBffBaseUrl) ?? DEFAULT_BFF_BASE_URL;
};

export const resolveLeadsServiceKind = (options: { shouldMockServices: boolean; useBff: boolean }): LeadsServiceKind => {
  if (options.shouldMockServices) return 'mock';
  return options.useBff ? 'bff' : 'legacy';
};
